import { createAsyncThunk } from "@reduxjs/toolkit";
import { FetchRequestHandler } from "../../utils/commonUtilities";
import { baseUrl } from "../../constants/Endpoints/EndPoints";


export const fetchBrighterScoreCarrierApi = createAsyncThunk(
    "fetchBrighterScoreCarrierApi",
    async ({practiceId,providersId}) => {
        const result = await FetchRequestHandler("get", `${baseUrl}api/practices/${practiceId}/providers/${providersId}/brighter-scores?filter-by=carrier`);
        return result;
    }
)


export const fetchBrighterScoreApi = createAsyncThunk(
    "fetchBrighterScoreApi",
    async ({practiceId,providersId}) => {
        const result = await FetchRequestHandler("get", `${baseUrl}api/practices/${practiceId}/providers/${providersId}/brighter-scores`);
        return result;
    }
)